import React from 'react'
import DateTimeInput from './DateTimePicker'

export const DateTimePicker = (props) => {
  return <DateTimeInput {...props} />
}
